import { Tooltip } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";
import React from "react";

interface Props {
  disable?: boolean;
  tooltip?: string;
  children?: JSX.Element;
  className?: string;
  inline?: boolean;

  /**
   * By default, there's padding applied to the HoverOverDiv. This can disable it
   */
  hasPadding?: boolean;
}
const MaybeDisable = ({ disable, tooltip, children, className, inline, hasPadding }: Props) => {
  if (!children) {
    return <div className={clsx(inline && "inline-block", className)} />;
  }
  if (tooltip && disable) {
    return (
      <div className={clsx(inline && "inline-block", className)}>
        <Tooltip title={tooltip}>
          <div
            className={clsx(
              "inline-block w-full hover:cursor-pointer",
              (hasPadding ?? true) && "pt-px",
            )}
          >
            <div className="inline-block w-full opacity-50 pointer-events-none transition-opacity duration-300">
              {children}
            </div>
          </div>
        </Tooltip>
      </div>
    );
  }
  return (
    <div className={clsx(inline && "inline-block", className)}>
      <div
        className={clsx(
          "inline-block w-full",
          disable && "opacity-50 pointer-events-none transition-opacity duration-300",
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default MaybeDisable;
